/*  MUI  */
import { KeyboardDoubleArrowDown } from '@mui/icons-material';

/* Shared */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const PartnerIcon = () => {
    const { t } = useTranslation();

    return (
        <DarkTooltip arrow title={t('Common.partner_note')}>
            <KeyboardDoubleArrowDown
                sx={{ color: 'notes.icon.partner' }}
                fontSize="large"
            />
        </DarkTooltip>
    );
};
